import API from "@/api/lib/api";

export const getAllFloors = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/floors`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const getAllRooms = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/rooms`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getAllFloorsWithoutPagination = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/floors-all`);    
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const getAllRoomsWithoutPagination = async (restaurant_id, floor_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/rooms-all?floor_id=${floor_id}&status=active`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleFloor = async (item_id) => {
  try {
    const response = await API.get(`restaurant/floors/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const getSingleRoom = async (item_id) => {
  try {
    const response = await API.get(`restaurant/rooms/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createFloor = async (data) => {  
  try {
    const response = await API.post(`restaurant/floors`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating floor:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};
export const createRoom = async (data) => {  
  try {
    const response = await API.post(`restaurant/rooms`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const updateFloor = async (item_id, data) => {  
  try {
    const response = await API.put(`restaurant/floors/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const updateRoom = async (item_id, data) => {  
  try {
    const response = await API.put(`restaurant/rooms/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleFloorStatus = async (id) => {
  try {
    const response = await API.put(`restaurant/floors/${id}/update-status`);
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const toggleRoomStatus = async (id) => {
  try {
    const response = await API.put(`restaurant/rooms/${id}/update-status`);
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteFloor = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/floors/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const deleteRoom = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/rooms/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

// table
export const getAllTables = async (room_id) => {
  try {
    const response = await API.get(`restaurant/rooms/${room_id}/tables`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const getAllTablesWithRoom = async (room_id) => {
  try {
    const response = await API.get(`restaurant/live-table/rooms/${room_id}/tables`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const createTable = async (data) => {  
  try {
    const response = await API.post(`restaurant/tables`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const updateTable = async (item_id, data) => {  
  try {
    const response = await API.put(`restaurant/tables/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const updateTableSize = async (item_id, data) => {  
  try {
    const response = await API.put(`restaurant/tables/${item_id}/update-table-size`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createBookingTable = async (data) => {  
  try {
    const response = await API.post(`restaurant/bookings`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};
export const updateBookingTable = async (bookingId, value) => {    
  try {
    const response = await API.put(`restaurant/bookings/${bookingId}`, value);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const getBookingById = async (bookingId) => {
  try {
    const response = await API.get(`restaurant/bookings/${bookingId}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getBookingByTableAndId = async (tableId, bookingId) => {
  try {
    const response = await API.get(`restaurant/tables/${tableId}/bookings/${bookingId}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const assignTable = async (id, value) => {    
  try {
    const response = await API.post(`restaurant/reservations/${id}/assign-tables`, value);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const updateLiveBookingTable = async (bookingId, value) => {    
  try {
    const response = await API.put(`restaurant/live-table/tables/${bookingId}/update-status`, value);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const quickBookingTable = async (data) => {  
  try {
    const response = await API.post(`restaurant/bookings/quick`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};
export const mergeTable = async (data) => {  
  try {
    const response = await API.post(`restaurant/table-merges`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};
export const updateMergeTable = async (id, data) => {  
  try {
    const response = await API.put(`restaurant/table-merges/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};
export const swapTable = async (id, data) => {  
  try {
    const response = await API.put(`restaurant/bookings/${id}/swap-table`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const getSingleTable = async (table_id, booking = false) => {
  try {
    const response = await API.get(`restaurant/tables/${table_id}?booking=${booking}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getBookingHistory = async (
  restaurant_id,
  {
    page = 1,
    per_page = 10,
    start_date,
    end_date,
    search_term,
    sort_field = "id",
    sort_order = "desc",
  }
) => {
  const params = {
    page,
    per_page
  };

  const isValid = v => v != null && String(v).trim() !== '';

  if (isValid(start_date)) params.start_date = start_date;
  if (isValid(end_date)) params.end_date = end_date;
  if (isValid(search_term)) params.search_term = search_term;
  if (isValid(sort_field)) params.sort_field = sort_field;
  if (isValid(sort_order)) params.sort_order = sort_order;

  try {
    const response = await API.get(`restaurant/${restaurant_id}/bookings/history`, { params });
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};